export default "__VITE_ASSET__cxfH166$__"